import queryString from "query-string";

import NetworkError from "./networkError";

const DEFAULT_TIMEOUT = 15 * 1000;

export enum RequestMethod {
  Get = "GET",
  Post = "POST",
  Put = "PUT",
  Delete = "DELETE",
}

export function serialiseQueryParameters(
  params: Record<string, string>,
): string {
  return queryString.stringify(params);
}

export function sendRequest(
  url: string,
  method: RequestMethod,
  params?: RequestInit,
  timeout: number = DEFAULT_TIMEOUT,
): Promise<Response> {
  let id: number;
  const timeoutPromise = new Promise((_, reject) => {
    id = setTimeout(() => {
      clearTimeout(id);
      reject(new NetworkError(`Timeout after ${timeout} milliseconds`));
    }, timeout);
  });

  return Promise.race([
    fetch(url, {
      ...params,
      method,
    }).then((response) => {
      clearTimeout(id);
      return response;
    }),
    timeoutPromise,
  ]) as Promise<Response>;
}

export function get(
  url: string,
  urlParameters?: Record<string, string>,
  otherParams?: RequestInit,
  timeout?: number,
): Promise<Response> {
  const fullUrl = urlParameters
    ? `${url}?${serialiseQueryParameters(urlParameters)}`
    : url;
  return sendRequest(fullUrl, RequestMethod.Get, otherParams, timeout);
}

export function del(
  url: string,
  urlParameters?: Record<string, string>,
  otherParams?: RequestInit,
  timeout?: number,
): Promise<Response> {
  const fullUrl = urlParameters
    ? `${url}?${serialiseQueryParameters(urlParameters)}`
    : url;
  return sendRequest(fullUrl, RequestMethod.Delete, otherParams, timeout);
}

export function post(
  url: string,
  requestBody: BodyInit,
  params?: RequestInit,
  timeout?: number,
): Promise<Response> {
  return sendRequest(
    url,
    RequestMethod.Post,
    {
      ...params,
      body: requestBody,
    },
    timeout,
  );
}

export function put(
  url: string,
  requestBody: BodyInit,
  params?: RequestInit,
  timeout?: number,
): Promise<Response> {
  return sendRequest(
    url,
    RequestMethod.Put,
    {
      ...params,
      body: requestBody,
    },
    timeout,
  );
}
